export const REPORT_MANDATORY_OPTIONS = [];

export const PREOFFER_INITIAL_OPTIONS = [
  {
    label: "Phone",
    value: "candidate.candidateSubmissionData.phone",
    sort: true,
    sortValue: "c.candidate_submission_data->>'phone'",
  },
  {
    label: "Email",
    value: "candidate.candidateSubmissionData.email",
    sort: true,
    sortValue: "c.candidate_submission_data->>'email'",
  },
  {
    label: "Nationality",
    value: "candidate.candidateSubmissionData.candidateNationality",
    sort: true,
    sortValue: "c.candidate_submission_data->>'candidateNationality'",
  },
  {
    label: "Current Status",
    value: "status",
    sort: true,
    sortValue: "pre_offer_verification.status",
  },
  {
    label: "Offer Status",
    value: "subStatus",
    sort: true,
    sortValue: "pre_offer_verification.sub_status",
  },
  {
    label: "Candidate Owner",
    value: "candidate.candidateSubmissionData.candidateOwner",
    sort: true,
    sortValue: "c.candidate_submission_data->>'candidateOwner'",
  },
  {
    label: "Joining Date",
    value: "joiningDate",
    sort: true,
    sortValue: "joiningDate",
  },
  {
    label: "Contract End Date",
    value: "contractEndDate",
    sort: true,
    sortValue: "contractEndDate",
  },
  {
    label: "Created By",
    value: "createdByName",
    sort: true,
    sortValue: "pre_offer_verification.created_by",
  },
  {
    label: "Last Updated",
    value: "updatedAt",
    sort: true,
    sortValue: "pre_offer_verification.updatedAt",
  },
];

export const SEARCH_FIELDS = [
  "pre_offer_verification.case_no",
  "pre_offer_verification.status",
  "pre_offer_verification.sub_status",
  "j.job_submission_data->>'jobId'",
  "j.job_submission_data->>'jobTitle'",
  "c.first_name",
  "c.last_name",
  "c.candidate_submission_data->>'candidateOwner'",
  "c.candidate_submission_data->>'phone'",
  "c.candidate_submission_data->>'email'",
  "c.candidate_submission_data->>'candidateNationality'",
  "c.candidate_submission_data->>'visaStatus'",
];

export const BGC_STATUS = {
  COMPLETED: "Pre-Offer Required",
  VERIFIED: "Pre-Offer Verified",
  REJECTED: "Pre-Offer Pending",
  CREATE_OFFER_DRAFT: "Create-Offer Draft",
  CREATE_OFFER_SUBMITTED: "Offer Created",
  OFFER_REVIEWED: "Offer Reviewed",
  CORRECTION_NEEDED: "Correction Needed",
  OFFER_APPROVED: "Offer Approved",
  OFFER_SHARED: "Share Offer",
  OFFER_REJECTED: "Offer Rejected",
  OFFER_ACCEPTED: "Offer Accepted",
  OFFER_DECLINED: "Offer Declined",
  OFFER_RENEGOTIATION: "Offer Renegotiation",
  BGC_IN_PROGRESS: "BGC In Progress",
  BGC_REJECTED: "BGC Rejected",
  BGC_COMPLETED: "BGC Completed",
  MOM_BGC_IN_PROGRESS: "MOM BGC In Progress",
  MOM_BGC_COMPLETED: "MOM BGC Completed",
  SC_IN_PROGRESS: "SC In Progress",
  SC_COMPLETED: "SC Completed",
  SC_REJECTED: "SC Rejected",
  VISA_IN_PROGRESS: "Visa In Progress",
  VISA_COMPLETED: "Visa Completed",
  ONBOARDING_PENDING: "Onboarding",
  ONBOARDING_DOCUMENTS_UPLOADED: "Onboarding",
  ONBOARDING_COMPLETED: "Onboarding",
  CONTRACT_END: "Contract End",
  CONTRACT_RENEWED: "Contract Renewed",
};

export const BGC_SUB_STATUS = {
  BGC_INITIATED: "Initiated",
  MOM_BGC_INITIATED: "Initiated",
  PENDING_FROM_VENDOR: "Pending From Vendor",
  UNABLE_TO_VERIFY: "Unable To Verify",
  BGC_COMPLETED: "Completed",
  COMPLETED: "Completed",
  PENDING: "Pending",
  MOM_BGC_PENDING: "Pending",
  APPLICATION: "Application",
  DOCUMENT_SUBMISSION: "Document Submission",
  MOM_BGC_COMPLETED: "Completed",
  SC_COMPLETED: "Completed",
  SC_PENDING: "Pending",
  SC_REJECTED: "Rejected",
  VISA_APPLICATION: "Application",
  VISA_DOCUMENT_SUBMISSION: "Document Submission",
  VISA_PENDING: "Pending",
  VISA_COMPLETED: "Completed",
  OFFER_REVISED: "Offer Revised",
  ONBOARDING_PENDING: "Initiated",
  ONBOARDING_COMPLETED: "Completed",
  TERMINATE: "Terminate Contract",
  RESIGNATION: "Resignation",
  CONVERSION: "Conversion to Permanent",
  CONTRACT_RENEWED: "Renewed",
};
